import * as core from '../../../../../../../core'

import { query } from './proposal-table.query'

export const RESOURCE = {
  payload: {
    alias: 'proposals.table',
    description: 'Table used to display and explore proposals',
    name: 'Proposals Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
